"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Condition = void 0;
const with_class_name_1 = require("./with-class-name");
class Condition extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.name = '';
        this.negate = false;
    }
}
exports.Condition = Condition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/condition.js
// module id = 1216
// module chunks = 0